<form class="geaui-grid-col-12" [formGroup]="commitForm" (ngSubmit)="save()">
  <div class="dialog-body">
    <geaui-input-v3
      [id]="'summary'"
      [label]="'Enter a summary of your changes'"
      [placeholder]="'Enter a summary of your changes'"
      [formGroupInput]="commitForm"
      [formFieldName]="'summary'"
      [required]="true">
    </geaui-input-v3>
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    <geaui-button-v3 [type]="'secondary'" (click)="close()">Cancel</geaui-button-v3>
    <geaui-button-v3 [disabled]="!commitForm.valid" [sending]="isLoading()" (click)="save()">Save</geaui-button-v3>
  </div>
</form>
